/* eslint-disable @angular-eslint/no-input-rename */
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconName } from '@vsolv/vectors-ui/icons';
import { TableCellComponent } from '../../models';
import { ButtonCellProps } from '../button';

export interface IconButtonCellProps extends Omit<ButtonCellProps, 'text' | 'iconStart' | 'iconEnd'> {
  icon: IconName;
  tooltipText?: string;

  href?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: `
    <ng-container *ngIf="data">
      <div
        (click)="data.disabled && $event.stopImmediatePropagation()"
        [vsTooltip]="data.tooltipText"
        tooltipStyle="light"
        tooltipPosition="top"
      >
        <a
          *ngIf="data.routerLink; else hrefTemplate"
          vs-icon-button
          [ngClass]="data.extraClasses"
          [target]="data.target"
          [routerLink]="data.routerLink"
          [theme]="data.theme"
          [appearance]="data.type || 'default'"
          [rounded]="data.rounded || false"
          [disabled]="data.disabled || false"
          (click)="$event.stopPropagation()"
        >
          <vs-icon class="text-lg" [name]="data.icon"></vs-icon>
        </a>

        <ng-template #hrefTemplate>
          <a
            *ngIf="data.href; else buttonTemplate"
            vs-icon-button
            [ngClass]="data.extraClasses"
            [href]="data.href"
            [target]="data.target"
            [theme]="data.theme"
            [appearance]="data.type || 'default'"
            [rounded]="data.rounded || false"
            [disabled]="data.disabled || false"
            (click)="$event.stopPropagation()"
          >
            <vs-icon class="text-lg" [name]="data.icon"></vs-icon>
          </a>
        </ng-template>

        <ng-template #buttonTemplate>
          <button
            vs-icon-button
            type="button"
            [ngClass]="data.extraClasses"
            [theme]="data.theme"
            [appearance]="data.type || 'default'"
            [rounded]="data.rounded || false"
            [disabled]="data.disabled || false"
            [vsTooltip]="data.tooltipText"
            tooltipStyle="light"
            tooltipPosition="top"
            (click)="$event.stopPropagation(); _click()"
          >
            <vs-icon class="text-lg" [name]="data.icon"></vs-icon>
          </button>
        </ng-template>
      </div>
    </ng-container>
  `,
})
export class IconButtonCellComponent extends TableCellComponent<IconButtonCellProps> {
  async _click() {
    await this.data?.click?.();
  }
}
